module.exports = __webpack_public_path__ + "img/2016_alloottees_gma.434c76fc.jpg";